import { render, staticRenderFns } from "./accountAliasComponent.vue?vue&type=template&id=eeeeead4&scoped=true&"
import script from "./accountAliasComponent.vue?vue&type=script&lang=js&"
export * from "./accountAliasComponent.vue?vue&type=script&lang=js&"
import style0 from "./accountAliasComponent.vue?vue&type=style&index=0&id=eeeeead4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeeeead4",
  null
  
)

export default component.exports